// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1VXzk","rootSuccess":"CompleteLink_rootSuccess__18unx","rootFailure":"CompleteLink_rootFailure__1xVHR","isDisabled":"CompleteLink_isDisabled__3Q5rZ"};